import React, { useEffect, useState } from "react";
import SystemCertificateForm from "./SystemCertificateForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/systemCertificateActions";
import History from "../../../History";
import { types, getNameAndExt, makeTranslates } from './utils';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const SystemCertificateCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateSystemCertificate, onFetchProductType } = props;

    const [productTypes, setProductTypes] = useState([]);
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });

    const handleUpload = event => {
        let eventFile = event[0];
        let fullName = getNameAndExt(eventFile?.name);

        let file = new File([eventFile], fullName);
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return;
        }
        setFileToSend({ fileToSend: file, fileName: file.name, imageValue: URL.createObjectURL(file) });
    };

    useEffect(() => {
        const fetchProductTypes = async () => {
            let productTypesList = await onFetchProductType({ ActiveCustomerID: activeCustomerID });
            setProductTypes(productTypesList);
        }
        if (productTypes?.length <= 0) {
            fetchProductTypes();
        }

        return () => { };

    }, [activeCustomerID, onFetchProductType, productTypes])

    const handleSubmit = async data => {
        const formData = new FormData();
        formData.append("File", fileToSend.fileName ? fileToSend.fileToSend : null);
        formData.append("FileName", fileToSend.fileName.toLowerCase() || null);
        formData.append("ActiveCustomerID", activeCustomerID);
        formData.append("Name", data?.Name);
        formData.append("Type", data?.Type);

        let productTypeIDs = Array.from(new Set((data?.ProductTypes ?? []).map(el => el.value)));

        formData.append("ProductTypes", JSON.stringify(productTypeIDs));

        let token = localStorage.getItem("SESSION");

        formData.append("Token", token);

        let result = await onCreateSystemCertificate(formData);
        if (result) {
            History.goBack();
        }
    };

    const productTypesWithTranslations = (productTypes ?? []).map(el => ({
        'value': el.value,
        'name': el.key,
        'label': makeTranslates(el.key + "")
    }));

    let initialValues = {
        Name: "",
        Type: types && types[0] ? types[0]?.value : '',
        ProductTypes: productTypesWithTranslations ? productTypesWithTranslations : [],
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Type: Yup.string().required("Required"),
            ProductTypes: Yup.array().required("Required")
        },
        FormTitle: translations["create_system_certificate"] || "Create system certificate",
        ButtonSubmit: hasPermission(permissions, "system_certificate_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <SystemCertificateForm
                        imageValue={fileToSend?.imageValue}
                        handleUpload={handleUpload}
                        classes={classes}
                        productTypes={productTypesWithTranslations}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID || null,
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchProductType: params => dispatch(actions.listProductTypes(params)),
        onCreateSystemCertificate: systemCertificate => dispatch(actions.createSystemCertificate(systemCertificate))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SystemCertificateCreate));